"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyDigestType = exports.StudyDigestVerificationStatus = exports.StudyDigestHashingStatus = void 0;
var StudyDigestHashingStatus;
(function (StudyDigestHashingStatus) {
    StudyDigestHashingStatus["Wait"] = "WAIT";
    StudyDigestHashingStatus["Processing"] = "PROCESSING";
    StudyDigestHashingStatus["Refreshing"] = "REFRESHING";
    StudyDigestHashingStatus["Done"] = "DONE";
    StudyDigestHashingStatus["Failed"] = "FAILED";
    StudyDigestHashingStatus["NotAvailable"] = "NOT_AVAILABLE";
    StudyDigestHashingStatus["Refreshable"] = "REFRESHABLE";
    StudyDigestHashingStatus["Contaminated"] = "CONTAMINATED";
})(StudyDigestHashingStatus = exports.StudyDigestHashingStatus || (exports.StudyDigestHashingStatus = {}));
var StudyDigestVerificationStatus;
(function (StudyDigestVerificationStatus) {
    StudyDigestVerificationStatus["Wait"] = "WAIT";
    StudyDigestVerificationStatus["Valid"] = "VALID";
    StudyDigestVerificationStatus["Invalid"] = "INVALID";
})(StudyDigestVerificationStatus = exports.StudyDigestVerificationStatus || (exports.StudyDigestVerificationStatus = {}));
var StudyDigestType;
(function (StudyDigestType) {
    StudyDigestType["Capture"] = "CAPTURE";
    StudyDigestType["QueryMessage"] = "QUERY_MESSAGE";
    StudyDigestType["QueryStatus"] = "QUERY_STATUS";
})(StudyDigestType = exports.StudyDigestType || (exports.StudyDigestType = {}));
//# sourceMappingURL=studyDigest.js.map